import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=9627f1dc&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=9627f1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9627f1dc",
  null
  
)

export default component.exports